import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { REELS } from "@/lib/site";

const LOOKS = [
  { img: "https://images.unsplash.com/photo-1600685890506-593fdf55949b?auto=format&fit=crop&w=1000&q=80", label: "The Muhurtham Look", tall: true },
  { img: "https://images.unsplash.com/photo-1688382654723-a7366006519b?auto=format&fit=crop&w=1000&q=80", label: "Pastel Bride" },
  { img: "https://images.unsplash.com/photo-1570212773364-e30cd076539e?auto=format&fit=crop&w=1000&q=80", label: "Everyday Grace" },
  { img: "https://images.unsplash.com/photo-1778148046574-c1509f5a40d4?auto=format&fit=crop&w=1000&q=80", label: "Chandbali Hour", tall: true },
  { img: "https://images.pexels.com/photos/35059564/pexels-photo-35059564.jpeg?auto=compress&cs=tinysrgb&w=1200", label: "Trousseau Flatlay" },
  { img: "https://images.unsplash.com/photo-1779475546066-742c9a580de1?auto=format&fit=crop&w=1000&q=80", label: "Temple Morning" },
  { img: "https://images.unsplash.com/photo-1787831398033-d70495c1e8a4?auto=format&fit=crop&w=1000&q=80", label: "Kundan & Kemp", tall: true },
  { img: "https://images.unsplash.com/photo-1760163287823-8786a65fd269?auto=format&fit=crop&w=1000&q=80", label: "Goppur Detail" },
];

export default function Lookbook() {
  return (
    <main className="pt-24 lg:pt-32">
      <section className="mx-auto max-w-[1440px] px-4 sm:px-8 lg:px-16 py-12 lg:py-16" data-testid="lookbook-page">
        <Reveal>
          <p className="overline-tag">The Lookbook</p>
          <h1 className="mt-3 max-w-3xl font-display text-5xl sm:text-6xl font-semibold text-ink leading-tight">
            The pieces, worn the way they were meant to be
          </h1>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-14" data-testid="lookbook-reels">
            <div className="flex items-end justify-between gap-4">
              <h2 className="font-display text-3xl sm:text-4xl font-semibold">In motion — our Instagram reels</h2>
              <span className="hidden sm:block font-mono text-[10px] text-ink3">tap to play with sound</span>
            </div>
            <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {REELS.map((r, i) => (
                <div key={r.id} className="card-surface p-2.5 transition-colors duration-300 hover:border-gold/40" data-testid={`lookbook-reel-${r.id}`}>
                  <iframe
                    src={`https://www.instagram.com/reel/${r.id}/embed`}
                    title={`Sashti Jewels lookbook reel ${i + 1}`}
                    className="w-full h-[500px] sm:h-[540px]"
                    frameBorder="0"
                    scrolling="no"
                    loading="lazy"
                    allowFullScreen
                  />
                </div>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <h2 className="mt-20 font-display text-3xl sm:text-4xl font-semibold">Stills from the atelier</h2>
        </Reveal>
        <div className="mt-8 columns-2 lg:columns-3 gap-4 [&>*]:mb-4">
          {LOOKS.map((l, i) => (
            <Reveal key={l.label} delay={(i % 3) * 0.06}>
              <figure className="group relative overflow-hidden border border-line bg-bg2">
                <img
                  src={l.img}
                  alt={l.label}
                  loading="lazy"
                  className={`w-full object-cover transition-transform duration-[1.4s] group-hover:scale-[1.05] ${l.tall ? "aspect-[3/4.4]" : "aspect-[3/3.6]"}`}
                />
                <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#14100A]/85 to-transparent p-4 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                  <span className="font-display text-lg font-semibold text-[#F7F4EE]">{l.label}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-20 border border-gold/30 bg-bg2 p-10 text-center sm:p-14">
            <p className="overline-tag">Want This Look?</p>
            <h2 className="mx-auto mt-3 max-w-xl font-display text-3xl sm:text-4xl font-semibold text-ink">
              Our concierge will style the whole set for you
            </h2>
            <Link to="/shop" className="btn-gold mt-8" data-testid="lookbook-shop-cta">
              Shop the Looks <ArrowUpRight size={15} />
            </Link>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
